export default __webpack_public_path__ + "static/media/dive-down.4b1c8f02.png";